"use client";
import React from "react";
import Link from "./webflow_modules/Basic/components/Link";

export function MarketToggleCityLink({
  link = {
    href: "#",
  },

  text = "Text Link",
}) {
  return (
    <Link
      button={false}
      className={"text-color-grey"}
      id={"w-node-_8e90f9c2-b8a6-ea23-2c24-33a3ef757187-ef757187"}
      options={link}
    >
      {text}
    </Link>
  );
}
